import { render } from "./CalendarHeader.vue?vue&type=template&id=443ce822&scoped=true"
import script from "./CalendarHeader.vue?vue&type=script&lang=js"
export * from "./CalendarHeader.vue?vue&type=script&lang=js"

import "./CalendarHeader.vue?vue&type=style&index=0&id=443ce822&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443ce822"]])

export default __exports__